module.exports = __webpack_public_path__ + "img/stock-4.266e5cbe.jpg";